import { render, staticRenderFns } from "./LogsTable.vue?vue&type=template&id=7c6e0480&scoped=true&"
import script from "./LogsTable.vue?vue&type=script&lang=js&"
export * from "./LogsTable.vue?vue&type=script&lang=js&"
import style0 from "./LogsTable.css?vue&type=style&index=0&id=7c6e0480&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6e0480",
  null
  
)

export default component.exports